export default "__VITE_PUBLIC_ASSET__c583ccbf__"